<div class="auth-shell">
  @if (showLocale()) {
    <div class="auth-locale">
      <div class="auth-locale-dropdown">
        <span class="auth-locale-current">
          <span class="auth-flag">{{ currentLang().flag }}</span>
          {{ currentLang().label }}
          <span class="auth-arrow"></span>
        </span>
        <ul class="auth-locale-list">
          @for (lang of languages(); track lang.value) {
            <li>
              <a (click)="selectLang(lang.value); $event.preventDefault()" href="#" class="auth-locale-link">
                <span class="auth-flag">{{ lang.flag }}</span>
                {{ lang.label }}
              </a>
            </li>
          }
        </ul>
      </div>
    </div>
  }
  <div class="auth-bg">
    <div class="orb orb-1"></div>
    <div class="orb orb-2"></div>
    <div class="orb orb-3"></div>
  </div>

  <div class="auth-card">
    <div class="brand">
      <div class="brand-icon">
        <img src="/logo-whitout-text.png" alt="JRetail" class="brand-icon-img" />
      </div>
      <h1>{{ 'jretail_basic' | translate }}</h1>
      <p>{{ 'retail_management_portal' | translate }}</p>
    </div>

    <div class="card-body">
      <router-outlet></router-outlet>
    </div>

    <div class="card-footer">
      <span dir="ltr">{{ 'copyright_kalem' | translate: { year: year } }}</span>
    </div>
  </div>
</div>
